(function () {
  function onLoopWidgetLoaded(onetimeOption) {
    let onetimePrice = onetimeOption.querySelector('.loop-widget-purchase-option-price')?.textContent;
    let compareAtPrice = onetimeOption.querySelector('.loop-widget-purchase-option-compare-at-price');

    if (compareAtPrice) {
      compareAtPrice.textContent = onetimePrice;
      compareAtPrice.classList.remove('loop-display-none');
    }

    if (onetimePrice) {
      const discount = window.themeVariables.settings.discountAmount / 100;
      if (discount == 0) return;

      onetimePrice = onetimePrice.replace('$', '');
      onetimePrice = parseFloat(onetimePrice) * discount;

      onetimeOption.querySelector('.loop-widget-purchase-option-price').textContent = '$' + onetimePrice.toFixed(2);
    }
  }

  const observer = new MutationObserver((mutationsList, observer) => {
    const onetimeOption = document.querySelector('[data-loop-widget-onetime-purchase-option]');

    if (onetimeOption) {
      onLoopWidgetLoaded(onetimeOption);
      observer.disconnect();
    }
  });

  if (document.body.classList.contains('super-saver')) {
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
